define('gameInterfaces/gameInterfacesRouting',[],function () {

    return function (
        navigation,
        publishNavigationComplete
    ) {

        return {
            afterAppStart: function () {

                navigation.ROUTES = {
                    ERROR: 'error',
                    GAMES: 'games',
                    HISTORY_BETS: 'history-bets',
                    MICROGAMING: 'microgaming',
                    NETENT: 'netent',
                    PLAYNGO: 'playngo',
                    QUICKSPIN: 'quickspin'
                };

                navigation.mapRoutes([
                        {
                            id: navigation.ROUTES.GAMES,
                            route: 'games',
                            redirect: navigation.ROUTES.ERROR
                        },
                        {
                            id: navigation.ROUTES.HISTORY_BETS,
                            route: 'cash/history/bets',
                            redirect: navigation.ROUTES.ERROR
                        },
                        {
                            id: navigation.ROUTES.MICROGAMING,
                            route: 'gameInterfaces/microgaming',
                            moduleId: 'microgamingGameInterfaceViewModel'
                        },
                        {
                            id: navigation.ROUTES.NETENT,
                            route: 'gameInterfaces/netent',
                            moduleId: 'netentGameInterfaceViewModel'
                        },
                        {
                            id: navigation.ROUTES.PLAYNGO,
                            route: 'gameInterfaces/playngo',
                            moduleId: 'playNGoGameInterfaceViewModel'
                        },
                        {
                            id: navigation.ROUTES.QUICKSPIN,
                            route: 'gameInterfaces/quickspin',
                            moduleId: 'quickspinGameInterfaceViewModel'
                        }
                    ])
                    .buildNavigationModel()
                    .mapUnknownRoutes('gameInterfacesError');

                navigation.getRouter().on('router:navigation:complete', function (instance, instruction) {
                    publishNavigationComplete(instruction);
                });

                navigation.activateRouter({
                    pushState: true
                });

            }
        };
    };
});


